import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import defaultSettings from '@/settings.js'
import qs from 'qs'

window._axiosPromiseArr = []
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
  headers: {
    'content-type':'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    config.cancelToken = new axios.CancelToken(cancel => {
      window._axiosPromiseArr.push({ cancel })
    })
    
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */
  response => {
    if(response.config.responseType == 'blob' || response.data.type == 'application/octet-stream') {
      return response.data
    }
    const res = response.data
    // 业务逻辑错误
    if (res.code !== 200) {
      window._axiosPromiseArr.forEach((ele,index) => {
        ele.cancel() // 清空（终止）上一个页面正在请求的内容
        delete window._axiosPromiseArr[index]
      })

      if(res.code == '402') {
        // Message({
        //   message: '抱歉，暂未找到您所查找的内容，请重新查询~',
        //   type: 'info',
        //   showClose: true,
        //   duration: 2 * 1000
        // })
        // MessageBox.confirm('抱歉，暂未找到您所查找的内容，请重新查询~', '', {
        //   confirmButtonText: '确定',
        //   showCancelButton: false,
        //   // type: 'info',
        //   center: true
        // }).then().catch(err => {})
        res.data = null
        return res;
      }else {
        MessageBox.confirm('抱歉，服务器开了个小差，请稍后重试~', '', {
          confirmButtonText: '确定',
          showCancelButton: false,
          // type: 'info',
          center: true
        }).then().catch(err => {
        })
      }
      return Promise.reject(new Error(res.message || '网络错误'))
    } else {
      return res;
    }
  },
  error => {
    window._axiosPromiseArr.forEach((ele,index) => {
      ele.cancel() // 清空（终止）上一个页面正在请求的内容
      delete window._axiosPromiseArr[index]
    })
    console.log('error:' + error) // for debug
    
    //清除请求
    if(error == 'Cancel') {
      return;
    }

    if(error.code === 'ECONNABORTED' || error.message ===   "Network Error" ||  error.message.includes("timeout")){  
      MessageBox.confirm('请求超时，请稍后重试~', '', {
        confirmButtonText: '确定',
        showCancelButton: false,
        // type: 'info',
        center: true
      }).then().catch(err => {})
      return;
    }

    MessageBox.confirm('抱歉，服务器开了个小差，请稍后重试~', '', {
      confirmButtonText: '确定',
      showCancelButton: false,
      // type: 'info',
      center: true
    }).then().catch(err => {})
    return Promise.reject(error)
  }
)

export default service
